<template>
    <div>
        <div
                class="modal fade"
                id="deals-my-poll-popup"
                tabindex="-1"
                role="dialog"
                aria-labelledby="deals-my-poll-popup"
                aria-hidden="true"
        >
            <div class="modal-dialog window-popup edit-my-poll-popup" role="document">
                <div class="modal-content">
                    <a href="#" class="close icon-close" data-dismiss="modal" aria-label="Close">
                        <svg class="olymp-close-icon">
                            <use xlink:href="svg-icons/sprites/icons.svg#olymp-close-icon" />
                        </svg>
                    </a>
                    <div class="modal-body" ref="showMatchReviewBox">
                        <!-- <div class="control-block-button post-control-button">
                          <a href="#" class="btn btn-control has-i bg-facebook">
                            <i class="fab fa-facebook-f" aria-hidden="true"></i>
                          </a>

                          <a href="#" class="btn btn-control has-i bg-twitter">
                            <i class="fab fa-twitter" aria-hidden="true"></i>
                          </a>
                        </div>-->

                        <div class="edit-my-poll-head bg-mdd">
                            <div class="head-content">
                                <h2 class="title">Create a Deal</h2>
                                <div v-if="setSearchResults !== 0" class="place inline-items">
                                    <svg class="olymp-add-a-place-icon">
                                        <use xlink:href="svg-icons/sprites/icons.svg#olymp-add-a-place-icon" />
                                    </svg>
                                    <span>{{ homeTeamName }}</span>
                                    <span>{{ awayTeamName }}</span>
                                </div>
                            </div>

                            <div v-if="setSearchResults !== 0" class="sidebyside">
                                <img class="poll-img" :src="home_team_logo" :alt="homeTeamName" />
                                <h4>VS</h4>
                                <img class="poll-img" :src="away_team_logo" :alt="awayTeamName" />
                            </div>
                        </div>

                        <div class="edit-my-poll-content">
                            <response-message :data="errorData" />
                            <form method="post" id="deals_form" enctype="multipart/form-data" class="resume-form">
                                <h3>Submit Your Deal</h3>
                                <div class="row">
                                    <div class="col col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <div @click="getImageDeal()" class="form-group with-button">
                                            <input
                                                    class="form-control"
                                                    id="imageNameDeal"
                                                    placeholder="Browse Image..."
                                                    value
                                                    type="text"
                                            />
                                            <button type="button" @click="getImageDeal()" class="bg-grey">
                                                <svg class="olymp-computer-icon">
                                                    <use xlink:href="/svg-icons/sprites/icons.svg#olymp-computer-icon" />
                                                </svg>
                                            </button>
                                        </div>
                                        <input
                                                type="file"
                                                @change="previewImage"
                                                style="display:none"
                                                id="getImageDeal"
                                                name="image_name"
                                        />
                                    </div>
                                    <div class="col col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <div class="form-group date-time-picker label-floating">
                                            <label class="control-label">Deal Name</label>
                                            <input
                                                    class="form-control"
                                                    id="dealName"
                                                    placeholder="Deal Name"
                                                    value
                                                    v-model="formModelReview.dealName"
                                                    type="text"
                                            />
                                        </div>
                                    </div>
                                    <div class="col col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <div class="form-group label-floating with-button">
                                            <label class="control-label">Deal Type</label>
                                            <select v-model="formModelReview.deal_type" class="form-control" id="deal_type">
                                                <option value="null" selected>None</option>
                                                <option value="restaurant">Restaurant</option>
                                                <option value="kit">Fan Kits</option>
                                                <option value="hotel">Hotels</option>
                                                <option value="odd">Odds</option>
                                                <option value="travel">Travel</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <div class="form-group date-time-picker label-floating">
                                            <label class="control-label">Deal Date</label>
                                            <input name="start-date" type="date" v-model="formModelReview.deal_date" value="" id="deal_date" />
                                            <span class="input-group-addon">
                                                <svg class="olymp-month-calendar-icon icon">
                                                  <use xlink:href="/svg-icons/sprites/icons.svg#olymp-month-calendar-icon" />
                                                </svg>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                        <div class="form-group label-floating with-button">
                                            <label class="control-label">Voucher Code</label>
                                            <button type="button" class="bg-grey">
                                                <svg class="olymp-computer-icon">
                                                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-happy-sticker-icon"></use>
                                                </svg>
                                            </button>
                                            <input
                                                    class="form-control"
                                                    id="voucher_code"
                                                    placeholder="Deal Voucher Code"
                                                    value
                                                    v-model="formModelReview.voucher_code"
                                                    type="text"
                                            />
                                        </div>
                                        <div class="form-group label-floating with-button">
                                            <label class="control-label">Link</label>
                                            <button type="button" class="bg-grey">
                                                <svg class="olymp-computer-icon">
                                                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-add-a-place-icon"></use>
                                                </svg>
                                            </button>
                                            <input
                                                    class="form-control"
                                                    id="deal_link"
                                                    placeholder="Deal Link"
                                                    value
                                                    v-model="formModelReview.link"
                                                    type="text"
                                            />
                                        </div>
                                        <div v-if="justPhoto === false" class="form-group label-floating is-empty">
                                            <label class="control-label">Deal Description</label>
                                            <textarea
                                                    v-model="formModelReview.review"
                                                    name="review"
                                                    class="form-control"
                                                    placeholder
                                                    id="review"
                                            ></textarea>
                                        </div>
                                        <button
                                                id="reviewPostButton"
                                                @click.prevent="uploadReview"
                                                class="btn bg-mdd btn-lg full-width"
                                        >Submit Review</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import jquery from "jquery";
    let $ = jquery;

    export default {
        name: "PostReview.vue",
        data() {
            return {
                homeTeamName: "",
                awayTeamName: "",
                home_team_logo: "",
                away_team_logo: "",
                setSearchResults: "",
                matchId: "",
                errorData: {},
                imageData: "string",
                imageName: "",
                formModelReview: {
                    review: "",
                    deal_date: "",
                    voucher_code: "",
                    deal_type: "",
                    link: "",
                    dealName: "",
                },
                justPhoto: false,
            };
        },
        methods: {
            showLoading() {
                let loader = this.$loader(this, this.$refs.showMatchReviewBox, {
                    loaderType: "spinner"
                });
                return loader;
            },
            setMatch() {
                // let loader = this.showLoading();
                this.errorData = {
                    isError: false
                };
                let matchId = this.setSearchResults;
                if (matchId === 0) {
                    this.matchId = 0
                } else {
                    this.axios
                        .get("fixtures/info/" + matchId)
                        .then(response => {
                            // loader.hide();
                            // console.log(response.data.data);
                            this.matchId = response.data.data.id;
                            this.homeTeamName = response.data.data.home_team_name;
                            this.awayTeamName = response.data.data.away_team_name;
                            this.home_team_logo = response.data.data.home_team_logo;
                            this.away_team_logo = response.data.data.away_team_logo;
                        })
                        .catch(error => {
                            // loader.hide();
                            $("#deals-my-poll-popup").modal("hide");
                            // console.log(error.response);
                            return error;
                        });
                }
            },
            getImageDeal() {
                $("#getImageDeal").click();
            },
            previewImage() {
                if ($("#getImageDeal").get(0).files.length > 0) {
                    if (
                        $("#getImageDeal")
                            .get(0)
                            .files[0].name.split(".")
                            .pop() !== "png" &&
                        $("#getImageDeal")
                            .get(0)
                            .files[0].name.split(".")
                            .pop() !== "jpg" &&
                        $("#getImageDeal")
                            .get(0)
                            .files[0].name.split(".")
                            .pop() !== "jpeg"
                    ) {
                        this.errorData = {
                            message: "Sorry image can only be (Jpg - Png)",
                            isError: true
                        };
                    } else {
                        let file = $("#getImageDeal").get(0).files[0].name;
                        $("#imageNameDeal").val(file);
                    }
                }
            },
            getImageDealDetails() {
                if ($("#getImageDeal").get(0).files.length > 0) {
                    let file = $("#getImageDeal").get(0).files[0].name;
                    $("#imageNameDeal").val(file);
                    var splitImageName = file.split(".");
                    return splitImageName[0];
                }
            },
            clearForm() {
                this.formModelReview.review = "";
                this.formModelReview.dealName = "";
                this.formModelReview.deal_date = "";
                this.formModelReview.deal_type = "";
                this.formModelReview.voucher_code = "";
                this.formModelReview.link = "";
                $("#getImageDeal").val("");
                $("#imageNameDeal").val("");
            },
            uploadReview() {
                $("#review").attr("disabled", true);
                $("#reviewPostButton").attr("disabled", true);
                $("#imageName").attr("disabled", true);
                $("#getImageDeal").attr("disabled", true);
                let loader = this.showLoading();

                if (this.validateForm()) {
                    if (this.formModelReview.deal_date)
                    if (this.getImageDealDetails() !== undefined) {
                        let file = $("#getImageDeal").get(0).files[0];
                        let formData = new FormData();
                        formData.append('file', file);
                        formData.append("fixture_id", this.matchId);
                        formData.append("description", this.formModelReview.review);
                        formData.append("name", this.formModelReview.dealName);
                        formData.append("deal_date", this.formModelReview.deal_date);
                        formData.append("voucher", this.formModelReview.voucher_code);
                        formData.append("type", this.formModelReview.deal_type);
                        formData.append("link", this.formModelReview.link);
                        this.axios({
                            method: "post",
                            url: "deals/create",
                            data: formData,
                            config: { headers: { "Content-Type": "multipart/form-data" } }
                        })
                            .then(response => {
                                // console.log("response", response);
                                loader.hide();
                                this.errorData = {
                                    message: "Your deal has been published successfully",
                                    isError: "success"
                                };
                                window.eventBus.$emit("dealsFeed", true);
                                this.clearForm();
                                return response;
                            })
                            .catch(error => {
                                console.log("error", error);
                                loader.hide();
                                this.errorData = {
                                    message: error.response,
                                    isError: true
                                };
                            })
                    }else {
                        let formData = new FormData();
                        formData.append("fixture_id", this.matchId);
                        formData.append("description", this.formModelReview.review);
                        formData.append("name", this.formModelReview.dealName);
                        formData.append("deal_date", this.formModelReview.deal_date);
                        formData.append("voucher", this.formModelReview.voucher_code);
                        formData.append("type", this.formModelReview.deal_type);
                        formData.append("link", this.formModelReview.link);
                        this.axios({
                            method: "post",
                            url: "deals/create",
                            data: formData,
                            config: { headers: { "Content-Type": "multipart/form-data" } }
                        })
                            .then(response => {
                                // console.log("response", response);
                                this.clearForm();
                                loader.hide();
                                this.errorData = {
                                    message: "Your deal has been published successfully",
                                    isError: "success"
                                };
                                window.eventBus.$emit("dealsFeed", true);
                                return response;
                            })
                            .catch(error => {
                                console.log("error", error);
                                loader.hide();
                                this.errorData = {
                                    message: error.response,
                                    isError: true
                                };
                            })
                    }
                }else {
                    loader.hide();
                }

            },
            validateForm() {
                var today = new Date();
                var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

                if (
                    !this.formModelReview.dealName &&
                    !this.formModelReview.deal_date &&
                     !this.formModelReview.link &&
                     !this.formModelReview.voucher_code &&
                     !this.formModelReview.deal_type
                ) {
                    $("#deals_form .label-floating").addClass('has-error');
                    $("#info_change_form input").addClass('form-control-danger');
                    this.errorData = {
                        message: "Sorry all fields are required",
                        isError: true
                    };
                    return false;
                }
                else if(
                    !this.formModelReview.deal_type
                ){
                    $("#deals_form input#deal_type").parent(".label-floating").addClass('has-error');
                    $("#deals_form input#deal_type").addClass('form-control-danger');
                    this.errorData = {
                        message: "Sorry a type of deal must be selected",
                        isError: true
                    };
                    return false;
                }

                else if(
                    !this.formModelReview.deal_date
                ){
                    $("#deals_form input#deal_date").parent(".label-floating").addClass('has-error');
                    $("#deals_form input#deal_date").addClass('form-control-danger');
                    this.errorData = {
                        message: "Sorry do give a start date",
                        isError: true
                    };
                    return false;
                }

                else if (this.formModelReview.deal_date < date) {
                    this.errorData = {
                        message: "Sorry date can not be a past date",
                        isError: true
                    };
                    return false;
                }

                else if(
                    !this.formModelReview.dealName
                ){
                    $("#deals_form input#dealName").parent(".label-floating").addClass('has-error');
                    $("#deals_form input#dealName").addClass('form-control-danger');
                    this.errorData = {
                        message: "Sorry a deal name cannot be empty",
                        isError: true
                    };
                    return false;
                }
                else if(
                    this.formModelReview.link !== "" && !this.$validate("link",this.formModelReview.link)
                ){
                    $("#deals_form input#deal_link").parent(".label-floating").addClass('has-error');
                    $("#deals_form input#deal_link").addClass('form-control-danger');
                    this.errorData = {
                        message: "Sorry your link url is wrong",
                        isError: true
                    };
                    return false;
                }
                //
                // else if(
                //     !this.formModelReview.review
                // ){
                //     $("#deals_form input#review").parent(".label-floating").addClass('has-error');
                //     $("#deals_form input#review").addClass('form-control-danger');
                //     this.errorData = {
                //         message: "Sorry a short description of a deal is needed",
                //         isError: true
                //     };
                //     return false;
                // }
                else {
                    $("#deals_form .label-floating").removeClass('has-error');
                    $("#deals_form input").removeClass('form-control-danger');
                    return true;
                }

            }
        },
        async mounted() {
            // set match id if emited id. this is coming from post photos button
            window.eventBus.$on("dealsMatchID", val => {
                this.setSearchResults = val;
                this.setMatch();
            });
            window.eventBus.$on("review_option", val => {
                if(val === "photo") {
                    this.justPhoto = true;
                } else if(val === "review") {
                    this.justPhoto = false;
                }
            });

            $(document).ready(function() {
                CRUMINA.Bootstrap();
            });

            CRUMINA.Bootstrap = function() {
                let moment;

                /* -----------------------------
                 * Date time picker input field
                 * Script file: daterangepicker.min.js, moment.min.js
                 * Documentation about used plugin:
                 * https://v4-alpha.getbootstrap.com/getting-started/introduction/
                 * ---------------------------*/
                var date_select_field = $('input[name="datetimepicker"]');
                /*moment.locale('uk');*/
                if (date_select_field.length) {
                    var start = moment().subtract(29, "days");

                    date_select_field.daterangepicker({
                        minDate: "12/05/1900",
                        startDate: start,
                        autoUpdateInput: false,
                        singleDatePicker: true,
                        showDropdowns: true,
                        locale: {
                            format: "DD/MM/YYYY"
                        }
                    });
                    date_select_field.on("focus", function() {
                        $(this)
                            .closest(".form-group")
                            .addClass("is-focused");
                    });
                    date_select_field.on("apply.daterangepicker", function(ev, picker) {
                        $(this).val(picker.startDate.format("DD/MM/YYYY"));
                        $(this)
                            .closest(".form-group")
                            .addClass("is-focused");
                    });
                    date_select_field.on("hide.daterangepicker", function() {
                        if ("" === $(this).val()) {
                            $(this)
                                .closest(".form-group")
                                .removeClass("is-focused");
                        }
                    });
                }
            };
        }
    }
</script>

<style scoped>

</style>
